<template>
    <div class="create-ticket-description-container-xl">
        <div class="d-flex m-bottom-5">
            <div>
                <img src="../assets/message-icon.svg" alt="" class="me-3" />
            </div>
            <span class="text-start color-primary mb-0">
                Write your problem in the section below; our support team will be in touch very
                soon!
            </span>
        </div>
        <div class="d-flex mb-4 position-relative">
            <input
                v-model="subject"
                type="text"
                placeholder="Subject"
                :class="subjectInputClass"
                class="d-inline-block"
                @input="handleSubjectChanges"
            />
            <span>
                <div class="">
                    <base-select
                        name="name"
                        key-name="id"
                        :searchable="false"
                        :items="categories"
                        v-model="selectedCategory"
                        @update:option="selectCategory"
                        style="width: 320px; margin-left: 20px"
                        placeholder="Select Category"
                    />
                </div>
            </span>
        </div>
        <textarea
            v-model="dsecription"
            placeholder="Describe your issue here ..."
            :class="textareaClass"
            @input="handleDescriptionChanges"
        ></textarea>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

// * components
import BaseSelect from '@/components/base/base-form-elements/BaseSelect.vue';

export default {
    components: {
        BaseSelect,
    },
    data() {
        return {
            subject: '',
            dsecription: '',
            selectedCategory: '',
            categoryMenuStatus: 'collapse',
        };
    },
    computed: {
        ...mapState({
            categories: (state) => state.createTicketStore.ticketCategories,
        }),
        subjectInputClass() {
            return this.subject === ''
                ? 'create-ticket-input-empty-xl'
                : 'create-ticket-input-fill-xl';
        },
        textareaClass() {
            return this.dsecription === ''
                ? 'create-ticket-textarea-empty-xl'
                : 'create-ticket-textarea-fill-xl';
        },
    },

    methods: {
        ...mapMutations('createTicketStore', [
            'HANDLE_DESCRIPTION',
            'HANDLE_SUBJECT',
            'HANDLE_CATEGORY_ID',
        ]),
        selectCategory(category) {
            this.selectedCategory = category.name;
            this.categoryMenuStatus = 'collapse';
            this.HANDLE_CATEGORY_ID(category.id);
        },
        handleSubjectChanges(event) {
            this.HANDLE_SUBJECT(event.target.value);
        },
        handleDescriptionChanges(event) {
            this.HANDLE_DESCRIPTION(event.target.value);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/DescriptionXl.scss';
</style>
